import useSWR, { preload } from "swr";

import { simpleFetcher } from "../fetcher";

interface UserDocumentRoles {
  ownerIn: { documentId: number; title?: string }[];
  publisherIn: { documentId: number; title: string }[];
}

const buildKey = (id: string | number) => `/api/v2/users/${id}/document-roles`;

export function useUserDocumentRoles(id: string | number | undefined) {
  return useSWR<UserDocumentRoles, Error>(
    id ? buildKey(id) : null,
    simpleFetcher,
  );
}

export async function getUserDocumentRoles(
  id: string | number,
): Promise<UserDocumentRoles> {
  return preload(buildKey(id), simpleFetcher) as Promise<UserDocumentRoles>;
}
